module.exports = __webpack_public_path__ + "img/02.0f5c6c50.jpg";